import {ModuleProto} from "../../module-proto";
import {ModuleType} from "../../types";
import {SettingsMenuTopCategory} from "../../settings-module";
import gitlabIntegration_Disable from "../../../../app/integrations/settings/gitlab-com/actions/disable";
import {SettingsParentSection} from "../../../../app/settings/const";
import {Feature} from "../../../gd/access-control/feature-access/const";

// const debug = "GitlabModule"
const debug = false

export class GitlabModule extends ModuleProto {

    public repositories    : any
    public params          : any

    constructor() {
        super(ModuleType.GITLAB, {});

        debug && console.log(debug, "constructor() moduleConfig=")

        const gitlabConfig = gd.session.modules.get(gd.companyId)?.gitlab

        this.name                    = "Gitlab"
        this.description             = "Gitlab integration enables task mentioning and status update from git commit messages and allows linking git repositories, branches and commits from GoodDay tasks."
        this.svgIcon                 = "isvg-gitlab"
        this.settingsMenuTopCategory = SettingsMenuTopCategory.INTEGRATIONS
        this.typeLabel               = "Integrations"
        this.repositories            = []
        this.params                  = null
        this.settingsUrl             = "settings/integrations/gitlab"
        this.parentSection           = SettingsParentSection.INTEGRATIONS

        this._isEnabled              = true

        this.feature                 = Feature.GIT_INTEGRATION
        this.validateFeature()


        debug && console.log(debug, "_isEnabled", this._isEnabled)
    }

    disable = async ()=> {
        gitlabIntegration_Disable()
        gd.modules.saveConfig()
    }


    toJson() {
        debug && console.log(debug, "toJson() type=",this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }
}
